import { makeStyles, useTheme, useMediaQuery } from "@material-ui/core";
import React, { Fragment } from "react";
import Card from './cardItems';
import Carousel from "react-elastic-carousel";

let useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        ...theme.grid.gridMdContent,
        width: 1140,
        margin: "45px auto",
        maxWidth: '95%',
        '@media (max-width:1197px)': {
            width: 758,
        },
        '@media (max-width:600px)': {
            justifyContent: 'space-around',
        },
        '@media (max-width:421px)': {
            justifyContent: 'center',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    mobileWrap: {
        display: 'none',
        width: '100%',
        margin: '45px auto',
        padding: '0 16px',
        [theme.breakpoints.down('sm')]: {
            display: 'block',
        },
    },
    mobileTitle: {
        fontSize: theme.typography.pxToRem(18),
        fontWeight: 700,
        textAlign: 'center',
        marginBottom: 16,
        color: theme.palette.text.primary,
    },
    carouselWrap: {
        width: '100%',
        paddingBottom: 24,
        '& .rec-carousel': {
            maxWidth: '100%',
        },
        '& .rec-slide': {
            display: 'flex',
            justifyContent: 'center',
        },
        '& .rec-item': {
            maxWidth: 280,
        },
    },
}))

export default function Index() {

    let classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            {/* دسکتاپ: گرید کارت‌ها */}
            <div className={classes['root']}>
                {
                    dataService?.map((item, index) => (
                        <Fragment key={`desktop-oms-${item.link}-${index}`}>
                            <Card data={item} />
                        </Fragment>
                    ))
                }
            </div>

            {/* موبایل: عنوان + کاروسل با اتواسکرول */}
            {isMobile && (
                <div className={classes['mobileWrap']}>
                    <h2 className={classes['mobileTitle']}>سامانه های معاملاتی</h2>
                    <div className={classes['carouselWrap']}>
                        <Carousel
                            breakPoints={[{ width: 2, itemsToShow: 1}]}
                            enableAutoPlay
                            autoPlaySpeed={3000}
                            renderArrow={() => <span style={{ display: 'none' }} />}
                            renderPagination={() => <span style={{ display: 'none' }} />}
                        >
                            {dataService.map((item, index) => (
                                <div key={`oms-${item.link}-${index}`}>
                                    <Card data={item} />
                                </div>
                            ))}
                        </Carousel>
                    </div>
                </div>
            )}
        </>
    );
}


let dataService = [
    {
        title: "سامانه معاملات",
        desc: "آنلاین اکسیر",
        // icon: "/sprit.svg#service_ecxer",
        icon: "/assets/icons/service_ecxer.svg",
        link: "https://poyan.exirbroker.com",
        targetBlank: true
    },

    {
        title: "سامانه معاملات",
        desc: "آنلاین تدبیر",
        // icon: "/sprit.svg#service_ecxer",
        icon: "/assets/icons/service_classic.svg",
        link: "https://online.pouyanbroker.ir",
        targetBlank: true
    },
    {
        title: "اپلکیشن",
        desc: "تدبیر ",
        icon: "/assets/icons/app.svg",
        link: "https://mobile.pouyanbroker.ir",
        targetBlank: true
    },
    {
        title: "اپلکیشن",
        desc: "رایان همراه",
        icon: "/assets/icons/app.svg",
        link: "https://poyan.exirbroker.ir",
        targetBlank: true
    },
    {
        title: "سامانه معاملات",
        desc: "مشتقه کالا",
        icon: "/assets/icons/service_ati.svg",
        link: "https://coinonline.pouyanbroker.ir",
        targetBlank: true
    },
    {
        title: "سامانه معاملات",
        desc: "آنلاین کالا",
        icon: "/assets/icons/service_kala.svg",
        link: "https://pouyan.ebgo.ir/StockCode",
        targetBlank: true
    },

    // {
    //     title: "سامانه معاملات",
    //     desc: "آنلاین کلاسیک",
    //     icon: "/assets/icons/service_classic.svg",
    //     link: "https://poyan.irbroker.com",
    //     targetBlank: true
    // },
    // {
    //     title: "سامانه معاملات",
    //     desc: "آفلاین",
    //     icon: "/assets/icons/service_offline.svg",
    //     link: "https://poyan.irbrokersite.ir/",
    //     targetBlank: true
    // },




    // {
    //     title: "سامانه معاملات تدبیر",
    //     desc: "",
    //     icon: "system_online",
    //     link: "https://online.pouyanbroker.ir",
    //     targetBlank: true
    // },

    // {
    //     title: "رایان همراه (گوگل پلی)",
    //     desc: "",
    //     icon: "phone",
    //     link: "https://play.google.com/store/apps/details?id=com.rh.ot.android",
    //     targetBlank: true
    // },

    // {
    //     title: "آنلاین رایان همراه",
    //     desc: "",
    //     icon: "phone",
    //     link: "https://poyan.exirbroker.com/mobile/#view/login.html",
    //     targetBlank: true
    // },

]